export const positiveId = (value) => Number.isSafeInteger(value) && value > 0;
export const revision = (value) => Number.isSafeInteger(value) && value >= 0;
export const epoch = (value) => typeof value === 'string' && /^[a-f0-9]{48}$/.test(value);
export const utc = (value) => typeof value === 'string' &&
  /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.\d+)?Z$/.test(value) &&
  Number.isFinite(Date.parse(value));
export const date = (value) => typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value) &&
  Number.isFinite(Date.parse(`${value}T00:00:00Z`)) &&
  new Date(`${value}T00:00:00Z`).toISOString().slice(0, 10) === value;
const ids = (values) => Array.isArray(values) && values.every(positiveId) &&
  new Set(values).size === values.length;

export function validateEventPage(page) {
  if (!page || page.contract_version !== 1 || !epoch(page.scope_epoch) ||
      !['baseline', 'live'].includes(page.mode) || !utc(page.server_time_utc) ||
      typeof page.next_cursor !== 'string' || !/^[a-f0-9]{64}$/.test(page.next_cursor) ||
      typeof page.has_more !== 'boolean' || !ids(page.business_ids) ||
      !page.business_ids.length || !revision(page.preferences_revision) ||
      page.poll_after_ms !== 5000 || page.sound_freshness_ms !== 15000 ||
      typeof page.evaluator_fresh !== 'boolean' ||
      !(page.evaluator_last_observed_at === null || utc(page.evaluator_last_observed_at)) ||
      !Array.isArray(page.events) || page.events.length > 100 ||
      !Array.isArray(page.business_calendar) ||
      page.business_calendar.length !== page.business_ids.length ||
      new Set(page.business_calendar.map((c) => c?.business_id)).size !== page.business_ids.length ||
      page.business_calendar.some((c) => !c || !page.business_ids.includes(c.business_id) ||
        !(c.today === null || date(c.today)) || !(c.timezone === null || typeof c.timezone === 'string') ||
        !(c.reason === null || typeof c.reason === 'string')) ||
      (page.mode === 'baseline' && (page.events.length !== 0 || page.has_more))) {
    throw new Error('Invalid dispatcher event response');
  }
  let previous = 0;
  page.events.forEach((e) => {
    if (!e || !positiveId(e.id) || e.id <= previous || typeof e.event_type !== 'string' ||
        !['activity', 'exception_created', 'exception_changed', 'exception_resolved',
          'exception_acknowledged'].includes(e.kind) ||
        !utc(e.occurred_at) || !utc(e.observed_at) || !utc(e.published_at) ||
        typeof e.sound_candidate !== 'boolean' || typeof e.live_sound_eligible !== 'boolean' ||
        !e.calendar || typeof e.calendar.eligible !== 'boolean' ||
        !(e.order_id === null || positiveId(e.order_id))) throw new Error('Invalid dispatcher event');
    const message = e.event_type === 'new_driver_message';
    if (message ? (!ids(e.business_ids) || !e.business_ids.length ||
        e.business_ids.some((id) => !page.business_ids.includes(id)) ||
        !(e.business_id === null || e.business_ids.includes(e.business_id)) ||
        e.order_id !== null || !positiveId(e.message_id) || !positiveId(e.conversation_id) ||
        !positiveId(e.driver_id)) :
      (!positiveId(e.business_id) || !page.business_ids.includes(e.business_id) ||
        !positiveId(e.order_id))) throw new Error('Invalid dispatcher event scope');
    previous = e.id;
  });
  return page;
}
